
import axios from "axios";

console.log("pro0cees->", process.env)

let url = window.location.href.includes(process.env.REACT_APP_PROD_URL) ?
  process.env.REACT_APP_USER_MANAGEMENT_BACKEDN_PROD_URL :
  process.env.REACT_APP_USER_MANAGEMET_BACKEND_DEV_URL
export const client = axios.create({
  baseURL: url
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 500) {
      // localStorage.clear();
      // window.location.href = "/";
    }
    else if (error.response.status == 401) {
      localStorage.clear()
      window.location.href = "/login";
    }
    else {
      return error.response
    }
  }
);


let appUrl = window.location.href.includes(process.env.REACT_APP_PROD_URL) ?
  process.env.REACT_APP_ASSET_MANAGEMT_BACKEND_PROD_URL :
  process.env.REACT_APP_ASSET_MANAGEMT_BACKEND_DEV_URL
export const appclient = axios.create({
  baseURL: appUrl
});

appclient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 500) {
      // localStorage.clear();
      // window.location.href = "/";
    }
    else if (error.response.status == 401) {
      localStorage.clear()
      window.location.href = "/login";
    }
    else {
      return error.response
    }
  }
);





